import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../web.js";

export default class PageError
{
    requestPatchAccess(projectId, permission = "read")
    {
        web.projects.requestAccess(projectId, permission, (result) =>
        {
            ele.hide(ele.byId("request-access-button"));
            ele.show(ele.byId("request-pending-text"));
        });
    }

    showProject(targetEl)
    {
        const projectId = targetEl.dataset.projectId;
        api.get("projectinfo/" + projectId, (res) =>
        {
            const project = res.data.info.project;
            const user = res.data.info.user;
            const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": user, "displayedDate": "updated" });
            web.setHandleBarHtml("project", { "project": project, "projectInfo": projectInfo }, targetEl);
        }, () => {});
    }

    findOpEnvironments(targetEl)
    {
        const opIdentifier = targetEl.dataset.opidentifier;
        api.get("op/" + opIdentifier + "/find", (res) =>
        {
            if (res.data && res.data.environments && res.data.environments.length > 0)
            {
                let html = "<h3>Other environments:</h3><ul>";
                const opName = res.data.name;
                res.data.environments.forEach((envName) =>
                {
                    html += "<li>Found <a href=\"https://" + envName + "/op/" + opName + "\">" + opName + "</a> on <a href=\"https://" + envName + "/op/" + opName + "\">" + envName + "</a></li>";
                });
                html += "</ul>";
                targetEl.innerHTML = html;
            }
            else
            {
                targetEl.innerText = "";
            }
        }, (err) =>
        {
            targetEl.innerText = "";
        });
    }
}
